export default __webpack_public_path__ + "re_zooninglv2-800-ee574fe8543dd1610fa777b665278186.png";